module.exports = __webpack_public_path__ + "fa9ab201167523a64283fadd977d7255.MP3";